import DefaultCell from "application/components/DefaultCell";
import CTLDownloadFile from "application/components/CTLDownloadFile";
import PAPlayAudio from "application/components/PAPlayAudio";


const operationURLS = {
  list: "agentCDR/list",
  pdfDownload: "/agentCDR/generateAndDownloadPdf",
  csvDownload: "agentCDR/downloadCSV",
  csvFilterDownload: "agentCDR/downloadCSV1",
};

const getColumns = () => {
  return [
    {
      Header: "Queue Id",
      accessor: "queue",
      displayInList: true,
      allowFilter: true,
      allowReportColumn: true,
      allowReportFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "multipleSelect",
      options: {
        keyField: "queue",
        keyDescription: "queueName",
        values: [],
        url: "agentCDR/queues",
      },
    },
    {
      Header: "Queue Name",
      accessor: "queueName",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent ID",
      accessor: "agentName",
      displayInList: true,
      allowFilter: true,
      allowReportColumn: true,
      allowReportFilter: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      controlType: "multipleSelect",
      options: {
        keyField: "agentName",
        keyDescription: "fullName",
        values: [],
        url: "agentCDR/agents",
      },
    },
    {
      Header: "Agent Name",
      accessor: "fullName",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Campaign Name",
      accessor: "campaignName",
      displayInList: true,
      allowReportFilter: false,
      allowReportColumn: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Direction",
      accessor: "callDirection",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Caller ID",
      accessor: "agentTalkedTo",
      displayInList: true,
      allowReportFilter: false,
      allowReportColumn: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Hangup Cause",
      accessor: "hangupCause",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Start Stamp",
      accessor: "startTime",
      displayInList: true,
      allowFilter: true,
      allowReportFilter: true,
      allowReportColumn: true,
      defaultSortReport: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Answer Stamp",
      accessor: "answerTime",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "End Stamp",
      accessor: "endTime",
      displayInList: true,
      allowFilter: true,
      allowReportFilter: false,
      allowReportColumn: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Talk Time",
      accessor: "talkDuration",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dateTime: true,
      dataType: "date",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Duration",
      accessor: "duration",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Call Status",
      accessor: "isMissed",
      displayInList: true,
      allowReportFilter: false,
      allowReportColumn: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "MOS",
      accessor: "mos",
      displayInList: true,
      allowFilter: false,
      allowReportFilter: false,
      allowReportColumn: true,
      dataType: "integer",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Play",
      accessor: "",
      displayInList: true,
      downloadReports: false,
      sortDisable: true,
      Cell: ({ row }) => (
        <PAPlayAudio
          row={row}
          agentCallDataAnalysis={"agentCallDataAnalysis"}
        />
      ),
    },
    {
      Header: "Recording File",
      accessor: "recordingFile",
      downloadReports: false,
      displayInList: true,
      allowFilter: false,
      sortDisable: true,
      dataType: "string",
      Cell: ({ row, value }) => (
        <CTLDownloadFile
          row={row}
          value={value}
          agentCallDataAnalysis={"agentCallDataAnalysis"}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
